import type { BuilderCondition } from '../../lib/types.js';
import type { PickerVariable } from './definitionEdit.js';

export const conditionOperators = (kind: PickerVariable['kind']): BuilderCondition['op'][] => {
  switch (kind) {
    case 'boolean':
    case 'enum':
      return ['eq', 'neq', 'exists'];
    case 'number':
      return ['eq', 'neq', 'gt', 'lt', 'exists'];
    case 'string':
      return ['eq', 'neq', 'contains', 'exists'];
    case 'other':
      return ['exists'];
    default:
      return ['eq', 'neq', 'contains', 'gt', 'lt', 'exists'];
  }
};

export const OPS = [
  { value: 'eq', label: 'is' },
  { value: 'neq', label: 'is not' },
  { value: 'contains', label: 'contains' },
  { value: 'gt', label: 'is more than' },
  { value: 'lt', label: 'is less than' },
  { value: 'exists', label: 'has any value' },
];
